<ng-template #viewHeader>
  <ng-content></ng-content>
</ng-template>
